import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class PortalInfoDashboard extends Component {
  state = {
    jobs: [],
    mileage: [],
    last14DaysData: [],
    isLoading: true
  };

  componentDidMount() {
    if (typeof window !== 'undefined' && window.api_token) {
      this.loadinfoDashboardData();
      this.loadinfoDashboard14DaysData();
    } else {
      console.warn("API token is missing or window is undefined");
      this.setState({ isLoading: false });
    }
  }

  async loadinfoDashboardData() {
    const url = "/api/v1/portal/info-dashboard-data";
    if (!url) return this.setState({ isLoading: false });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + (window.api_token || ''),
          "Accept": "application/json"
        }
      });

      const data = response?.ok ? await response.json() : {};
      const jobTitles = ["Today", "Yesterday", "Last week", "Last month", "Last year"];
      const mileageTitles = ["Today", "Yesterday", "Last week", "Last month", "Last year"];

      this.setState({
        jobs: (data?.jobs || []).map((value, index) => {
          if (index > 4) return null;
          return {
            id: index + 1,
            title: jobTitles[index] || `Job ${index + 1}`,
            value: value ?? 0,
            previouseYearValue: data?.jobs[index + 5] ?? 0
          };
        }).filter(Boolean),
        mileage: (data?.mileage || []).map((value, index) => {
          if (index > 4) return null;
          return {
            id: index + 1,
            title: mileageTitles[index] || `Mileage ${index + 1}`,
            value: value ?? 0,
            previouseYearValue: data?.mileage[index + 5] ?? 0
          };
        }).filter(Boolean),
        isLoading: false
      });
    } catch (error) {
      console.error("Error loading dashboard data:", error);
      this.setState({ jobs: [], mileage: [], isLoading: false });
    }
  }

  async loadinfoDashboard14DaysData() {
    const url = "/api/v1/portal/info-dashboard-14-days-data";
    if (!url) return this.setState({ isLoading: false });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + (window.api_token || ''),
          "Accept": "application/json"
        }
      });

      const data = response?.ok ? await response.json() : {};
      const formatted = (data?.data || []).map((item, index) => ({
        id: index + 1,
        title: item.date,
        label: item.label,
        jobs: Number(item.jobs) ?? 0,
        mileage: Number(item.mileage) ?? 0
      }));

      this.setState({ last14DaysData: formatted, isLoading: false });
    } catch (error) {
      console.error("Error loading 14 days dashboard data:", error);
      this.setState({ last14DaysData: [], isLoading: false });
    }
  }

  renderCard(item) {
    if (!item) return null;
    return (
      <div key={item.id ?? Math.random()} className="info-dashboard-card" style={{ animationDelay: `${item.id * 0.1}s` }}>
        <div className="info-dashboard-primary">
          <h3 className="info-dashboard-card-title primary">{item.title ?? "N/A"}</h3>
          <p className="info-dashboard-card-value primary">{Number(item.value)?.toFixed(0) ?? 0}</p>
        </div>
        {(item.title !== "Last year") &&
          <div className="info-dashboard-compare">
            <h5 className="info-dashboard-card-title compare">Last Year</h5>
            <p className="info-dashboard-card-value compare">{Number(item.previouseYearValue)?.toFixed(0) ?? 0}</p>
          </div>}
      </div>
    );
  }

  render14DaysCard(item) {
    if (!item) return null;
    return (
      <div
        key={item.id ?? Math.random()}
        className="info-dashboard-card-14-days"
        style={{ animationDelay: `${item.id * 0.1}s` }}
      >
        <div className="info-dashboard-primary">
          <h3 className="info-dashboard-card-title-14-days primary">
            {item.title ?? "N/A"}
          </h3>
          <hr className="info-dashboard-divider-14-days" />
          <p className="info-dashboard-card-value-14-days primary">
            Jobs: {item.jobs}
          </p>
          <p className="info-dashboard-card-value-14-days primary">
            Miles: {item.mileage}
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { jobs, mileage, last14DaysData, isLoading } = this.state;
    if (isLoading) return <div className="info-dashboard-loading">Loading dashboard...</div>;
    return (
      <div id="g4-logistics-portal-dashboard-container" className="info-dashboard-container">
        <h2 className="info-dashboard-section-jobs">Completed Jobs</h2>
        <div className="info-dashboard-grid">
          {jobs.length ? jobs.map(this.renderCard) : <p>No job data available</p>}
        </div>

        <h2 className="info-dashboard-section-title-mileage">Miles Driven</h2>
        <div className="info-dashboard-grid">
          {mileage.length ? mileage.map(this.renderCard) : <p>No mileage data available</p>}
        </div>

        <h2 className="info-dashboard-section-title-last-14-days">Last 14 days completed jobs & miles</h2>
        <div className="info-dashboard-14days-grid">
          {last14DaysData.length
            ? last14DaysData.map(this.render14DaysCard)
            : <p>No data available</p>}
        </div>
      </div>
    );
  }
}

const domElement = document.getElementById('react-component-g4-logistics-portal-info-dashboard');
if (domElement) ReactDOM.render(<PortalInfoDashboard />, domElement);